// @ts-nocheck
import * as React from "react"

//COMPONENTS
import Loader from "../Loader";
import Banner from "../Banner";
import CardDetalleBlog from "../CardDetalleBlog"

const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';

export const Detalle = ({ setLoading, loading, data }: ComponentArticles) => {
    React.useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 2000)
    }, []);

    return (
        <main className="detail">
            <Banner
                backImage={{ desk: `/${THEMEURL}/sources/dist/assets/images/blog/bg_headerBlog.jpg`, mobile: `/${THEMEURL}/sources/dist/assets/blog/bg_headerBlog.jpg` }}
                textBanner={!loading ? 'Blog' : ''}
            />
            <div className="detail__content">
                <div className="detail__content-btn" data-aos="fade-down" data-aos-duration="1000">
                    <a className="btn" onClick={() => window.history.back()}>
                        <h3>{window.currentLang == 'es' ? 'Más noticias' : 'More news'}</h3>
                    </a>
                </div>
                <CardDetalleBlog articleInfo={data} />
                <div className="detail__content-btn detail__content-btn--bottom" data-aos="fade-down" data-aos-duration="1000">
                    <a className="btn" onClick={() => window.history.back()}>
                        <h3>{window.currentLang == 'es' ? 'Más noticias' : 'More news'}</h3>
                    </a>
                </div>
            </div>
        </main>
    )
}

export default Loader(Detalle)